var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimulator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "610.000000pt",
    height: "1258.000000pt",
    viewBox: "0 0 610.000000 1258.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1258.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1065 12549 c-354 -12 -562 -83 -744 -254 -149 -140 -236 -311 -278 -546 -17 -100 -18 -302 -18 -5464 0 -5162 1 -5364 18 -5464 77 -437 342 -703 777 -782 111 -21 4349 -21 4460 0 207 37 369 114 499 236 149 140 236 311 278 546 17 100 18 302 18 5469 0 5042 -1 5371 -17 5461 -77 424 -333 689 -748 774 -43 9 -155 18 -260 21 -265 8 -3769 10 -3985 3z m909 -262 c19 -19 24 -37 29 -112 10 -142 64 -227 176 -279 46 -21 53 -21 871 -21 l825 0 57 28 c106 52 155 134 165 274 5 73 10 91 29 110 l23 23 468 0 c257 0 509 -5 558 -10 201 -23 337 -82 450 -195 113 -113 172 -249 195 -450 14 -125 14 -10605 0 -10730 -23 -201 -82 -337 -195 -450 -113 -113 -249 -172 -450 -195 -123 -14 -4127 -14 -4250 0 -201 23 -337 82 -450 195 -113 113 -172 249 -195 450 -14 125 -14 10605 0 10730 23 201 82 337 195 450 110 110 250 172 436 194 41 5 291 9 557 10 l483 1 23 -23z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulator);
export default __webpack_public_path__ + "static/media/simulator.4a1f2e1f9cf0d463bfc3f6bd542f02d4.svg";
export { ForwardRef as ReactComponent };